import type { TableColumn, TableColumns } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';
import { ProductData } from '@pmp/types';

import { ProductBoSyncStatus } from './components/ProductBoSyncStatus';

// Only the products list shows it, and only where products are synced to BO: it is not one of the
// columns an import, an export or a change request carries.
export const boSyncStatusColumn: TableColumn<ProductData> = {
  title: 'pmp.products.labels.boSyncStatus',
  dataIndex: 'boSyncStatus',
  key: 'boSyncStatus',
  width: 140,
  render: (_: unknown, record: ProductData) => <ProductBoSyncStatus status={record.boSyncStatus} />,
  options: {
    filter: 'select',
    sorter: true,
    listName: FieldType.BO_SYNC_STATE,
    hideInForm: true,
  },
};

// Beside the group, since the status is the group's.
export const withBoSyncStatusColumn = (columns: TableColumns<ProductData>): TableColumns<ProductData> => {
  const groupIndex = columns.findIndex(column => column.key === 'group');
  return [...columns.slice(0, groupIndex + 1), boSyncStatusColumn, ...columns.slice(groupIndex + 1)];
};
